import React, { useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { IAppPropsWithRoute } from '../../../common/types';

import {
    Box, Grid,
    Button, IconButton,
    TextField, Select, MenuItem,
    FormHelperText, FormControl, FormControlLabel,
    RadioGroup, Radio, Checkbox,
    InputAdornment
} from '@material-ui/core';
import { useStyles } from "../styles";
import * as Icons from "../iconComponents";
import { useFormContext, Controller, useFieldArray } from "react-hook-form";
import IndexedDb from '../IndexedDb';
import { pcrstate } from "../../../store/modules/PcrSlice";
import { useSelector } from "react-redux";
interface PcrWidgetProps extends IAppPropsWithRoute {

};

const SubFormWidget: React.FC<PcrWidgetProps> = () => {
    const classes = useStyles();
    const pcr = useSelector(pcrstate)
    //const[value,setValue]=useState();
    const { watch, errors, control,setValue,getValues } = useFormContext();
    const infectiousStatus = watch("infectious_status");
    const[Indexdb,setIndexdb]=useState("");
    const [Infectiousstatuss, setInfectiousstatuss] = useState();
    const [Infectiousstatusdesc, setInfectiousstatusdesc] = useState();
    React.useEffect(() => {
        let db:any = null;
        db = localStorage.getItem("PatientDB");
        setIndexdb(db);
        getindexdbvalues();
    }, [])
    const getindexdbvalues = async (): Promise<void> => {
        let db:any = null;
        db = localStorage.getItem("PatientDB");
        if(db!=null && db !="")
        {
        const indexedDb = new IndexedDb(db);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let val = await indexedDb.getAllValue('background');
        for(let i=0;i<val.length;i++)
        {
            if(val[i].Key == "Infectiousstatus")
            {
                 setValue("infectious_status", val[i].value.column);
                //setInfectiousstatuss(val[i].value.column);
            }
            if(val[i].Key == "Infectiousstatusdesc")
            {
                setValue("Infectiousstatusdesc", val[i].value.column);
            }
        }
        }
    }
    const handleindexdbsave = async (Key:any,value:any): Promise<void> => {       
        if(Indexdb!=null || Indexdb !="")
        {
        const indexedDb = new IndexedDb(Indexdb);
        await indexedDb.createObjectStore(indexedDb.patientcarerecord);
        let res = await indexedDb.getValue('background', Key);
        await indexedDb.deleteValue('background', Key);
        await indexedDb.putValue('background', { column:value,Patid:0 },Key);
        }
    }
    const [textValue, setTextValue] = useState<string>("");

    const onTextChange = (e: any) => {setTextValue(e.target.value); console.log(textValue)} 
    const validate =async (value:any) => {
        var s = getValues("infectious_status");
        if(s == undefined && pcr.ValidateAllFields)
        {
            return 'Infectious status is required';
        }
    //     let db = localStorage.getItem("PatientDB");
    //     if(db!=null && db !="")
    //     {
    //     const indexedDb = new IndexedDb(db);
    //     await indexedDb.createObjectStore(indexedDb.patientcarerecord);
    //     let Patientidentification = await indexedDb.getAllValue('background');     
    //     if(Patientidentification.length > 0)
    //     { 
    //     for(let i=0;i<Patientidentification.length;i++)
    //     {   
    //       if(Patientidentification[i].Key == "Infectiousstatus")
    //       {     
    //         var dates = (Patientidentification[i].value.column);   
    //         if(dates === null)
    //         {
    //             return 'Infectious status field is required';
    //         }   
    //       }               
    //      }
    //     } 
    //     else
    //     {
    //       return 'Infectious status field is required';
    //     }
    //   }
    //   else
    //   {
    //     return 'Infectious status field is required';
    //   }
      };
    return (
        <div className={classes.backgroundSwitchItem}>
            <Controller
                control={control}
                name="infectious_status"
                defaultValue={Infectiousstatuss}
                render={({ onChange, onBlur, value, name }) => (
                    <>
                        <Grid container className={classes.buttonSwitchField}>
                            <Grid item xs={8} sm={8}>
                                <div>
                                { pcr.ValidateAllFields &&<Icons.RequiredIcon />}Infectious status
                                </div>
                            </Grid>
                            <Grid item xs={"auto"} sm={"auto"}>
                                <button
                                    type="button"
                                    className={value === 1 ? "selected" : ""}
                                    onClick={(e: any) => { onChange(1,handleindexdbsave('Infectiousstatus',1)) }}
                                >
                                    Yes
                                </button>
                                <button
                                    type="button"
                                    className={value === 0 ? "selected" : ""}
                                    onClick={(e: any) => { onChange(0,handleindexdbsave('Infectiousstatus',0)) }}
                                >
                                    No
                                </button>
                            </Grid>
                        </Grid>
                        <FormHelperText error={errors.infectious_status}>
                            {errors.infectious_status ? errors.infectious_status.message : ""}
                        </FormHelperText>
                        <div style={{ marginTop: 5 }}></div>
                        {(value === 1) && (<>
                        <div className="">
                                <Controller
                                    control={control}
                                    name="Infectiousstatusdesc"
                                    //defaultValue={Infectiousstatusdesc}
                                    render={({ onChange, onBlur, value, name }) => (
                                            <TextField
                                                variant='outlined'
                                                value={value}
                                                onChange={e => {
                                                    onChange(e)
                                                }}
                                                InputProps={{ classes: { root: classes.textFieldInput } }}
                                                inputProps={{ maxLength: 500, minLength: 0,autocomplete:'disabled' }}
                                                error={errors.infectious_status_desc} helperText={errors.infectious_status_desc ? errors.infectious_status_desc.message : ""}
                                                placeholder="List any active infections"                                                                           
                                                onBlur={(e) => {
                                                    handleindexdbsave('Infectiousstatusdesc',e.target.value);
                                                }}
                                            
                                                    />
                                                    )}
                                ></Controller>
                            </div>                                                                           
                            </>)}
                            </>
                            )}
                            rules={{
                                validate:validate                               
                            }}            
                            />
                        </div>
    );
}
export default React.memo(withRouter(SubFormWidget));